import React from 'react';
import { FlameIcon, Trash2Icon } from 'lucide-react';
import { CompletionToggle } from '../ui/CompletionToggle';
import { getLastNDays, formatWeekdayLetter, getTodayKey } from '../../utils/date';
import type { Habit } from '../../types/habit';
interface HabitCardProps {
  habit: Habit;
  streak: number;
  onToggleToday: () => void;
  onDelete?: () => void;
  compact?: boolean;
}
export function HabitCard({
  habit,
  streak,
  onToggleToday,
  onDelete,
  compact = false
}: HabitCardProps) {
  const todayKey = getTodayKey();
  const completedToday = habit.completions.includes(todayKey);
  const last7 = getLastNDays(7);
  return <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-49" data-mp="1hl2zb9iy3etr">
      <div className="flex items-center gap-3" data-id="element-50" data-mp="1cmhxj5o1on37">
        <CompletionToggle checked={completedToday} onChange={onToggleToday} label={`Mark ${habit.name} as done today`} colorClassName="bg-teal-600 border-teal-600" data-id="element-51" data-mp="1cjm1jmvrc8he" />
        <div className="min-w-0 flex-1" data-id="element-52" data-mp="2k7hqpw81ki87">
          <p className={`truncate text-sm font-medium ${completedToday ? 'text-slate-400 line-through' : 'text-slate-900'}`} data-id="element-53" data-mp="2k6g2sr5xg192">
            {habit.name}
          </p>
          {!compact && streak > 0 && <p className="mt-0.5 flex items-center gap-1 text-xs text-amber-600" data-id="element-54" data-mp="2b84fay0cxjku">
              <FlameIcon className="h-3 w-3" data-id="element-55" data-mp="2f96fbh23lznv" />
              {streak} day{streak === 1 ? '' : 's'} streak
            </p>}
        </div>
        {!compact && onDelete && <button type="button" onClick={onDelete} aria-label={`Delete ${habit.name}`} className="text-slate-300 transition-colors duration-150 hover:text-red-500" data-id="element-56" data-mp="37xc1874w1upa">
            <Trash2Icon className="h-4 w-4" data-id="element-57" data-mp="2yut0ptokru67" />
          </button>}
      </div>
      {!compact && <div className="mt-4 flex items-center justify-between" data-id="element-58" data-mp="1igaz36kasy3n">
          {last7.map(dayKey => {
        const done = habit.completions.includes(dayKey);
        const isToday = dayKey === todayKey;
        return <div key={dayKey} className="flex flex-col items-center gap-1" data-id="element-59" data-mp="3p7z8y4tm0n5w">
                <span className="text-[10px] font-medium uppercase text-slate-400" data-id="element-60" data-mp="3k7tiut2zn8px">{formatWeekdayLetter(dayKey)}</span>
                <span className={`h-2.5 w-2.5 rounded-full ${isToday ? 'ring-2 ring-teal-200 ring-offset-1' : ''}`} style={{
            backgroundColor: done ? '#14b8a6' : '#E2E8F0'
          }} data-id="element-61" data-mp="3fdyw1gs36dmm" />
              </div>;
      })}
        </div>}
    </div>;
}